import React from "react";
import PropTypes from "prop-types";
import { utils, useHeaderTitle } from "~/utils";

const ActivityDetailList = ({ activity, className, setheader }) => {

    useHeaderTitle(setheader, "Activity Information");

    return (
        <div className={["activity_detail", className].join(" ")}>
            <div className="content">
                <div className="row">
                    <div className="col-md-9">
                        <table className="table table-bordered">
                            {activity && (
                                <thead>
                                    <tr>
                                        <th scope="col">Activity Name</th>
                                        <td>{activity.activity_name}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">SMP Name</th>
                                        <td>{activity.smp_name}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Customer Team</th>
                                        <td>{activity.customer_team ? activity.customer_team.name : ''}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Is Active</th>
                                        <td>{activity.is_active ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Created By</th>
                                        <td>{activity.created_by}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Created at</th>
                                        <td>{utils.renderDate(activity.created_at, "DD/MM/YYYY hh:mm")}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Updated By</th>
                                        <td>{activity.updated_by}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Updated at</th>
                                        <td>{utils.renderDate(activity.updated_at, "DD/MM/YYYY hh:mm")}</td>
                                    </tr>
                                </thead>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

ActivityDetailList.propTypes = {
    activity: PropTypes.object,
    className: PropTypes.string,
    setheader: PropTypes.func
};

export default ActivityDetailList;